import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"arrow-right\"><path d=\"M339 256L122 35c-10-9-10-22 0-29 9-9 22-9 28 0l244 237c9 10 9 23 0 29L150 509c-9 9-22 9-28 0-10-10-10-23 0-29z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-right.svg
// module id = 178
// module chunks = 0